
import { Mentions} from "ant-design-vue";
const {...other } = Mentions;
const YwMentions = {
	...other,
	name: "YwMentions",
};

YwMentions.install = function (Vue) {
	Vue.component(YwMentions.name, Mentions);
};                                
export default YwMentions;
